<template>
    <v-container class="mt-12 pt-8" style="background:#fafafa;">
        <v-row style="background:#fafafa;">
            <v-col cols="12" class="pa-0">
                <v-row class="py-1 px-5">
                    <v-col cols="12" md="12">
                        <v-row>
                            <v-col cols="12" class="px-5" p-a-n-n-e-l-s>
                                <v-card notification-panel :loading="loading">
                                    <v-card-text class="py-0">
                                        <v-row>
                                            <v-col cols="12">
                                                <v-row class="align-center">
                                                    <v-col cols="2" class="text-center" t-i-t-l-e>
                                                        <v-icon size="40" color="secondary">account_tree</v-icon>
                                                    </v-col>
                                                    <v-col cols="10" t-i-t-l-e>
                                                        <div :class="`${arabic ? 'arFont' : 'enFont'} black--text`">
                                                            {{ i18n['all_settings'] }}
                                                        </div>
                                                        <div :class="`${arabic ? 'arFont' : 'enFont'} grey--text`">
                                                            {{ i18n['affiliate_settings_management'] }}
                                                        </div>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                            <v-col cols="12" md="6" class="text-center py-1" b-t-n>
                                                <v-autocomplete :items="resource.countries" v-model="selectedCountry"
                                                    :label="i18n['country']" autocomplete="disabled" outlined @click.stop=""
                                                    :filter="filterObject" hide-details clearable dense
                                                    @change="loadResource()" :loading="loading" item-value="id"
                                                    :class="`${arabic ? 'arFont' : 'enFont'}`">
                                                    <template v-slot:selection="{ attr, on, item, selected }">
                                                        <span v-bind="attr" :input-value="selected" v-on="on"
                                                            :class="`${arabic ? 'arFont' : 'enFont'}`">
                                                            <v-chip x-small>{{ item.name }} | {{ item.id }}</v-chip>
                                                        </span>
                                                    </template>
                                                    <template v-slot:item="{ item }">
                                                        <span :class="`${arabic ? 'arFont' : 'enFont'}`">
                                                            {{ item.name }} | {{ item.id }}
                                                        </span>
                                                    </template>
                                                </v-autocomplete>
                                            </v-col>
                                            <v-col cols="12" md="6" class="text-center py-1" b-t-n>
                                              <AccountAutocomplete
                                                :accounts="resource.accounts"
                                                :selectedItem="selectedAccount"
                                                @on-selected="accountChangedHandler"
                                                :loading="loading"
                                              />
                                            </v-col>
                                            <v-col cols="12" md="6" class="text-center py-0" BTN>
                                                <v-btn color="success" block :loading="loading" :class="`${arabic ? 'arFont' : 'enFont'}`" @click="dialog = true">
                                                    {{ i18n["add_new_settins"] }}
                                                    <v-icon right size="15">settings</v-icon>
                                                </v-btn>
                                            </v-col>
                                            <AffilaiteSettingsForm :affilaiteSetting="newResource" :loading="loading"
                                                :dialog="dialog" @closeDialog="closeDialog"
                                                :countries="resource.countries" @on-update="updateResource"
                                                :accounts="resource.accounts" @on-save="postResource" />

                                            <v-col cols="12">
                                                <v-row class="align-center">
                                                    <v-col cols="12" :class="`${arabic ? 'arFont' : 'enFont'}`">
                                                        <Paging :resource-settings="resourceSettings"
                                                            :resource="resource" @loadResource="loadResource"
                                                            @pageByNumber="pageByNumber" />
                                                    </v-col>
                                                    <v-col cols="12" :class="`${arabic ? 'arFont' : 'enFont'}`">
                                                        <v-expansion-panels focusable>
                                                            <v-expansion-panel v-for="(r, i) in resource.data"
                                                                :key="'resource-' + i" style="cursor:pointer;">
                                                                <v-expansion-panel-header>
                                                                    <v-row class="pa-0 align-center">
                                                                        <v-col cols="12" md="3"
                                                                            :class="`${arabic ? 'arFont' : 'enFont'} pa-0 py-1`">
                                                                            <div>
                                                                                {{ i18n['account'] }}:
                                                                                <span style="font-weight: bold;font-size:11px;">{{ r.account.name }}</span>
                                                                            </div>
                                                                            <div>
                                                                                {{ i18n['account_id'] }}:
                                                                                <span style="font-weight: bold;font-size:11px;">{{ r.account.id }}</span>
                                                                            </div>
                                                                        </v-col>

                                                                        <v-col cols="12" md="3"
                                                                            :class="`${arabic ? 'arFont' : 'enFont'} pa-0 py-1`">
                                                                            <div>
                                                                                {{i18n['country']}}:
                                                                                <span style="font-weight: bold;font-size:11px;">
                                                                                {{ getCountryLabelById(r.country_id) }}
                                                                                </span>
                                                                            </div>
                                                                            <div>
                                                                                {{ i18n["country_id"] }}:
                                                                                <span style="font-weight: bold;font-size:11px;">{{ r.country_id  }}</span>
                                                                            </div>
                                                                        </v-col>

                                                                        <v-col cols="12" md="2"
                                                                            :class="`${arabic ? 'arFont' : 'enFont'} pa-0 py-1`">
                                                                            <div>
                                                                                {{ i18n["percentage"] }}:
                                                                                <span style="font-weight: bold;">{{ `%${r.percentage}` }}</span>
                                                                            </div>
                                                                        </v-col>

                                                                        <v-col cols="12" md="2"
                                                                            :class="`${arabic ? 'arFont' : 'enFont'} pa-0 py-1`">
                                                                            <div>
                                                                                {{ i18n['commission'] }}:
                                                                                <span style="font-weight: bold;">{{ `${r.commission}$` }}</span>
                                                                            </div>
                                                                        </v-col>

                                                                        <v-col cols="12" md="2"
                                                                            :class="`${arabic ? 'arFont' : 'enFont'} pa-0 py-1 text-center`">
                                                                            <v-btn color="success" x-small
                                                                                :loading="loading"
                                                                                :class="`${arabic ? 'arFont' : 'enFont'}`"
                                                                                @click="toggleEditMode(r)">
                                                                                {{ i18n['edit'] }}
                                                                                <v-icon right size="15">settings</v-icon>
                                                                            </v-btn>
                                                                        </v-col>
                                                                    </v-row>
                                                                </v-expansion-panel-header>
                                                                <v-expansion-panel-content v-if="false">
                                                                    <v-divider class="pb-3"></v-divider>
                                                                    <v-row class="pa-0 align-center">

                                                                    </v-row>
                                                                </v-expansion-panel-content>
                                                            </v-expansion-panel>
                                                        </v-expansion-panels>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import Paging from '@/components/Paging';
import languageMixins from '@/mixings/language';
import AffilaiteSettingsForm from '@/components/AffilaiteSettingsForm';
import AccountAutocomplete from '@/components/AccountAutocomplete';

export default {
  components: {
    Paging,
    AffilaiteSettingsForm,
    AccountAutocomplete,
  },

  mixins: [languageMixins],

  data() {
    return {
      loading: false,
      dialog: false,
      resource: [],
      search: null,
      resourceKeys: [],
      resourceSettings: {
        resourceName: null,
        search: false,
        create: false,
        pagination: true,
      },
      newResource: {},
      resourceToUpdate: null,
      deleting: false,
      page: 1,
      selectedCountry: null,
      selectedAccount: null,
    };
  },
  methods: {
    closeDialog() {
      this.dialog = false;
      this.newResource = {};
    },
    toggleEditMode(r) {
      this.newResource = r;
      this.dialog = true;
    },
    async pageByNumber(n) {
      return new Promise(async (res) => {
        this.loading = true;
        this.page = n;
        if (!this.search) {
          this.resource = await this.$store.dispatch('getResource', {
            resource: this.$route.path,
            page: `?page=${this.page}${this.buildFilter()}`,
          });
        } else {
          this.resource = await this.$store.dispatch('searchResource', {
            resource: `${this.$route.path}/search?page=${this.page}`,
            value: this.search,
          });
        }
        this.loading = false;

        res(n);
      });
    },

    buildFilter() {
      let filter = '';
      if (this.selectedCountry) {
        filter += `&filter[country_id]=${this.selectedCountry}`;
      }
      if (this.selectedAccount) {
        filter += `&filter[account_id]=${this.selectedAccount.id}`;
      }
      return filter;
    },

    filterObject(item, queryText, itemText) {
      const v = Object.values(item).filter((x) => typeof x === 'string');
      let a = false;
      v.forEach((x) => {
        if (x.toLowerCase().includes(queryText.toLowerCase())) a = true;
      });
      if (itemText && typeof itemText === 'string' && itemText.toLowerCase().includes(queryText
        .toLowerCase())) a = true;
      return a;
    },

    getCountryLabelById(countryId) {
      const country = this.resource.countries.find(({
        id,
      }) => id === countryId);
      return country.name;
    },

    async loadResource() {
      return new Promise(async (res) => {
        this.loading = true;
        if (!this.search) {
          this.resource = await this.$store.dispatch('getResource', {
            resource: `${this.$route.path}?page=${this.page}${this.buildFilter()}`,
          });
        } else {
          this.resource = await this.$store.dispatch('searchResource', {
            resource: `${this.$route.path}/search?page=${this.page}`,
            value: this.search,
          });
        }
        this.loading = false;
        res();
      });
    },

    async postResource() {
      this.loading = true;
      const settings = this.newResource;

      await this.$store.dispatch('postResource', {
        resource: this.$route.path,
        value: settings,
      });
      await this.loadResource();

      this.newResource = {};
      this.dialog = false;
      this.loading = false;
    },

    async updateResource(data) {
      return new Promise(async (res) => {
        const settings = data;
        this.loading = true;

        await this.$store.dispatch('putResource', {
          resource: `${this.$route.path}/${settings.id}`,
          value: settings,
        });

        this.loadResource();

        this.newResource = {};

        this.dialog = false;
        this.loading = false;
        res(true);
      });
    },

    setResourceName() {
      this.resourceSettings.resourceName = this.i18n[this.$route.path.replace('/', '')];
    },

    accountChangedHandler(accountInfo) {
      this.selectedAccount = accountInfo;
      this.loadResource();
    },
  },

  computed: {
    api() {
      return this.$store.state.settings.apiBase;
    },

    users() {
      const sa = this.$store.state.user && this.$store.state.user.role === 'superadmin';
      return this.$store.state.users.filter((x) => {
        if (!sa) {
          return x.superior === this.$store.state.user.level;
        }
        return x;
      });
    },

    globalLoading() {
      return this.$store.state.globalLoading;
    },

    user() {
      return this.$store.state.user;
    },

    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },

    routeTitle() {
      const main = this.$store.state.menu.filter((x) => x.path === this.$route.path);
      const sub = [].concat(...this.$store.state.menu.map((x) => x.subs))
        .filter((x) => x).filter((x) => x.path === this.$route.path);
      if (main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text];
      }
      if (sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text];
      }
      return '';
    },

    roles() {
      return this.$store.state.userRoles;
    },
  },

  async created() {
    this.setResourceName();
    await this.loadResource();
  },
};
</script>

<style>

</style>
